import React from "react";
import { Link, useLocation } from "react-router-dom";

interface LayoutProps {
  user: {
    username: string;
    userId: string;
    signInDetails?: {
      loginId?: string;
    };
    displayName?: string;
    email?: string;
  };
  onSignOut: () => void;
  children: React.ReactNode;
}

export function Layout({ user, onSignOut, children }: LayoutProps) {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Dashboard" },
    { path: "/apis", label: "API Catalog" },
    { path: "/keys", label: "My API Keys" },
  ];

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1>M&B Internal API Developer Portal</h1>
          </Link>
          <nav className="nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="user-info">
            <span className="user-name">
              {user?.displayName ?? user?.email ?? user?.signInDetails?.loginId ?? "Developer"}
            </span>
            <button onClick={onSignOut} className="sign-out-btn">
              Sign Out
            </button>
          </div>
        </div>
      </header>
      <main className="main-content">{children}</main>
      <style>{`
        .layout { min-height: 100vh; display: flex; flex-direction: column; }
        .header { background: var(--color-surface); border-bottom: 1px solid var(--color-border); padding: 0 2rem; }
        .header-content { max-width: 1400px; margin: 0 auto; display: flex; align-items: center; gap: 2rem; height: 64px; }
        .logo { text-decoration: none; color: var(--color-text); }
        .logo h1 { font-size: 1.25rem; font-weight: 600; }
        .nav { display: flex; gap: 1.5rem; flex: 1; }
        .nav-link { color: var(--color-text-muted); font-weight: 500; padding: 0.5rem 0; border-bottom: 2px solid transparent; }
        .nav-link.active { color: var(--color-primary); border-bottom-color: var(--color-primary); }
        .user-info { display: flex; align-items: center; gap: 1rem; font-size: 0.875rem; }
        .user-name { color: var(--color-text); font-weight: 500; }
        .sign-out-btn { background: none; border: 1px solid var(--color-border); padding: 0.375rem 0.75rem; border-radius: 4px; cursor: pointer; font-size: 0.875rem; }
        .sign-out-btn:hover { background: var(--color-bg); }
        .main-content { flex: 1; max-width: 1400px; margin: 0 auto; padding: 2rem; width: 100%; }
      `}</style>
    </div>
  );
}
